import Vue from 'vue'
import Heb from './heb/index'


Vue.prototype.$CA = { Heb }